import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { Menu, X } from "lucide-react";
const menuToggleContent = {
  open: "Open navigation menu",
  close: "Close navigation menu"
};
interface MenuToggleProps {
  isOpen: boolean;
  onToggle: () => void;
  className?: string;
}
export const MenuToggle = t0 => {
  const $ = _c(7);
  const {
    isOpen,
    onToggle,
    className
  } = t0;
  const Icon = isOpen ? X : Menu;
  const dynamicAriaLabel = isOpen ? menuToggleContent.close : menuToggleContent.open;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon className="size-4 pointer-events-none" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== dynamicAriaLabel || $[4] !== onToggle || $[5] !== t1) {
    t2 = <Button onClick={onToggle} variant="secondary" icon={t1} iconPosition="right" isIcon={true} className={className} aria-label={dynamicAriaLabel} data-testid="menu-toggle-button" />;
    $[2] = className;
    $[3] = dynamicAriaLabel;
    $[4] = onToggle;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};